import { MobileDeviceUsageFilters } from '@reliance/types/filters/MobileDeviceUsageFilters';
import { useAsync } from 'react-async-hook';
import { IPaginatedResponse } from 'relcore-central';
import api from '../common/api';
import { Usage } from '@reliance/types/models/MobileDevice';

export const useMobileDeviceUsage = (filters: MobileDeviceUsageFilters) =>
  useAsync<IPaginatedResponse<Usage>>(
    () =>
      api
        .get<IPaginatedResponse<Usage>>('/mobile-device-usage', { params: { ...filters } })
        .then((r) => r.data),
    [filters]
  );

export const useMobileDeviceUsageByInmateId = (inmateId: number | null | undefined) =>
  useAsync<IPaginatedResponse<Usage>>(
    (currentInmateId?: number | null | undefined) => {
      const id = currentInmateId !== undefined ? currentInmateId : inmateId;
      if (!id) {
        return null;
      }
      return api
        .get<IPaginatedResponse<Usage>>('/mobile-device-usage', { params: { inmateId: id } })
        .then((r) => r.data);
    },
    inmateId === null ? [] : [inmateId]
  );
